import _ from 'lodash'
import axios from 'axios'
import config from '../variables/config'
import {
  fetchMembershipPrices,
  formatEmailMembershipPrice,
  getMembershipBillingAmount
} from '../containers/helpers/membershipPrices'

export const REQUEST_FAILED = 'users/REQUEST_FAILED'
export const REQUEST_STOP = 'users/REQUEST_STOP'
export const REQUEST_SENT = 'users/REQUEST_SENT'
export const REQUEST_FINISHED = 'users/REQUEST_FINISHED'
export const REQUEST_FINISHED2 = 'users/REQUEST_FINISHED2'
export const REGISTER_FINISHED = 'users/REGISTER_FINISHED'
export const FETCH_RECENT = 'users/FETCH_RECENT'
export const FETCH_ALL = 'users/FETCH_ALL'
export const FETCH_NONE = 'users/FETCH_NONE'
export const USER_REQUIRED = 'users/USER_REQUIRED'
export const USER_NOT_REQUIRED = 'users/USER_NOT_REQUIRED'
export const UPDATE_USER = 'users/UPDATE_USER'
export const UPDATE_WKUSER = 'users/UPDATE_WKUSER'
export const UPDATE_WKMEMBER = 'users/UPDATE_WKMEMBER'
export const CHECKING_REDIRECT = 'users/CHECKING_REDIRECT'
export const REDIRECT_DONE = 'users/REDIRECT_DONE'
export const FETCH_ALL_DONE = 'users/FETCH_ALL_DONE'
export const FETCH_NONE_DONE = 'users/FETCH_NONE_DONE'
export const SUBSCRIBE_FINISHED = 'users/SUBSCRIBE_FINISHED'
export const SET_MEMBERSHIP = 'users/SET_MEMBERSHIP'
export const CHANGE_PREVIEW = 'users/CHANGE_PREVIEW'

const initialState = {
  users: [],
  recentUsers: [],
  userForBooking: {
    user: {},
    redirect: '',
    required: false
  },
  redirectObj: {
    user: {},
    wasRedirect: false
  },
  requestFailed: false,
  requestLoading: false,
  requestFinished: false,
  fetchAllDone: false,
  fetchNoneDone: false,
  membership: {},
  subscribeFinished: false,
  image: ''
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_SENT:
      return {
        ...state,
        requestLoading: true
      }

    case REQUEST_FINISHED:
      return {
        ...state,
        requestLoading: false,
        requestFinished: true,
        recentUsers: [action.user, ...state.recentUsers],
        userForBooking: {
          user: state.userForBooking.required ? action.user : {},
          required: state.userForBooking.required
        }
      }

    case REQUEST_FINISHED2:
      return {
        ...state,
        requestLoading: false,
        requestFinished: true
      }

    case REQUEST_FAILED:
      return {
        ...state,
        requestFailed: true,
        requestLoading: false
      }

    case REQUEST_STOP:
      return {
        ...state,
        requestFailed: false
      }

    case REGISTER_FINISHED:
      return {
        ...state,
        requestFailed: false,
        requestFinished: false
      }

    case FETCH_RECENT:
      return {
        ...state,
        recentUsers: _.uniqBy(
          _.flatten([action.users, state.recentUsers]),
          'id'
        )
      }

    case FETCH_ALL:
      return {
        ...state,
        fetchAllDone: true,
        users: action.users
      }
    case FETCH_NONE:
      return {
        ...state,
        fetchNoneDone: true,
        users: action.users
      }

    case FETCH_ALL_DONE:
      return {
        ...state,
        fetchAllDone: false
      }
    case FETCH_NONE_DONE:
      return {
        ...state,
        fetchNoneDone: false
      }

    case USER_REQUIRED:
      return {
        ...state,
        userForBooking: {
          user: {},
          required: true,
          redirect: action.redirect
        }
      }

    case USER_NOT_REQUIRED:
      return {
        ...state,
        userForBooking: {
          redirect: '',
          required: false,
          user: {}
        }
      }

    case UPDATE_USER:
      return {
        ...state,
        users: action.users,
        recentUsers: action.recentUsers
      }

    case UPDATE_WKUSER:
      return {
        ...state,
        users: action.users,
        recentUsers: action.recentUsers
      }

    case UPDATE_WKMEMBER:
      return {
        ...state,
        membership: action.membership
      }

    case CHECKING_REDIRECT:
      return {
        ...state,
        redirectObj: {
          user: action.user,
          wasRedirect: true
        }
      }

    case REDIRECT_DONE:
      return {
        ...state,
        redirectObj: {
          user: {},
          wasRedirect: false
        }
      }

    case SET_MEMBERSHIP:
      return {
        ...state,
        membership: action.membership
      }

    case SUBSCRIBE_FINISHED:
      return {
        ...state,
        subscribeFinished: true
      }

    case CHANGE_PREVIEW:
      return {
        ...state,
        image: action.image
      }

    default:
      return state
  }
}

export const newUser = data => {
  return async (dispatch, getState) => {
    const token = getState().admin.token
    data.address = {
      city: data.city,
      county: data.county,
      country: data.country,
      street1: data.address1,
      street2: data.address2,
      postcode: data.postcode
    }

    delete data['city']
    delete data['county']
    delete data['country']
    delete data['address1']
    delete data['address2']
    delete data['postcode']

    data.adminId = getState().admin.user.id
    try {
      dispatch({ type: REQUEST_SENT })
      const response = await axios.post(
        config.serverURL + '/OnsiteUsers?access_token=' + token,
        data
      )

      dispatch({
        type: REQUEST_FINISHED,
        user: response.data
      })
    } catch (error) {
      dispatch({ type: REQUEST_FAILED })
    }
  }
}

async function fetchMembershipEmailUser (token, userId) {
  try {
    const { data } = await axios.get(
      config.serverURL +
        '/OnsiteUsers/' +
        userId +
        '?filter={"include":["guardians"]}&access_token=' +
        token
    )
    if (data && data.id) return data
  } catch (error) {
    const status = error.response && error.response.status
    if (status && status !== 404) throw error
  }

  // Search results mix OnsiteUsers and WKUsers. A website account is not an
  // OnsiteUser, and WKUser has no guardians relation.
  const { data } = await axios.get(
    config.serverURL + '/WKUsers/' + userId + '?access_token=' + token
  )
  return { ...data, guardians: data.guardians || [] }
}

async function sendMembershipConfirmationEmail (token, membership, userId) {
  const user = await fetchMembershipEmailUser(token, userId)
  const prices = await fetchMembershipPrices(token)
  const price = formatEmailMembershipPrice(membership, prices)
  const emailDetails = {
    name: user.firstName,
    type: membership.type,
    interval: membership.interval === 'monthly' ? 'Monthly' : 'Yearly',
    guardians: user.guardians,
    reference: membership.reference,
    email: user.email,
    membershipPrice: price
  }
  await axios.post(
    config.serverURL + '/sendMembershipConfirmation?access_token=' + token,
    emailDetails
  )
}

async function createMembershipRecord (token, membership) {
  if (membership.isStripe || config.useStripeMemberships) {
    const { data } = await axios.post(
      config.serverURL + '/stripe/membership?access_token=' + token,
      { membership: { ...membership, isStripe: true } }
    )
    return data.created || data
  }
  const { data } = await axios.post(
    config.serverURL + '/Memberships?access_token=' + token,
    membership
  )
  return data
}

export const subscribeMember = data => {
  return async (dispatch, getState) => {
    try {
      const token = getState().admin.token

      const membership = (await axios.get(
        config.serverURL + '/Memberships/' + data.id + '?access_token=' + token
      )).data

      // Stripe memberships are already active after card payment — only email.
      if (membership.isStripe || String(membership.subscriptionId || '').startsWith('sub_')) {
        await sendMembershipConfirmationEmail(token, membership, membership.userId)
        dispatch({ type: REQUEST_FINISHED2 })
        return
      }

      const prices = await fetchMembershipPrices(token)
      const amountPounds = getMembershipBillingAmount(membership, prices)

      var subscribe = {
        membershipId: data.id,
        amount: Math.round(amountPounds * 100)
      }

      const response = (await axios.post(
        config.serverURL + '/Memberships/subscribe?access_token=' + token,
        subscribe
      )).data
      if (response.status.status === 'fail') {
        dispatch({ type: REQUEST_FAILED })
        return
      }

      await sendMembershipConfirmationEmail(token, membership, membership.userId)

      dispatch({ type: REQUEST_FINISHED2 })
    } catch (error) {
      dispatch({ type: REQUEST_FAILED })
    }
  }
}

export const unsubscribeMember = data => {
  return async (dispatch, getState) => {
    const token = getState().admin.token
    var subscribe = {
      membershipId: data.id
    }
    try {
      await axios.post(
        config.serverURL + '/Memberships/unsubscribe?access_token=' + token,
        subscribe
      )
      dispatch({ type: REQUEST_FINISHED2 })
    } catch (error) {
      dispatch({ type: REQUEST_FAILED })
    }
  }
}

export const updateMember = data => {
  return async (dispatch, getState) => {
    const token = getState().admin.token

    try {
      await axios.patch(
        config.serverURL + '/Memberships/' + data.id + '?access_token=' + token,
        data
      )
      dispatch({ type: UPDATE_WKMEMBER })
    } catch (error) {
      dispatch({ type: REQUEST_FAILED })
    }
  }
}

export const previewMember = data => {
  return async (dispatch, getState) => {
    const token = getState().admin.token
    var preview = {
      membershipId: data.id
    }
    try {
      const response = (await axios.post(
        config.serverURL + '/Memberships/preview?access_token=' + token,
        preview
      )).data
      dispatch({ type: CHANGE_PREVIEW, image: response.image })
    } catch (error) {
      dispatch({ type: REQUEST_FAILED })
    }
  }
}

export const removePreview = data => {
  return async (dispatch, getState) => {
    dispatch({ type: CHANGE_PREVIEW, image: '' })
  }
}

export const updateAndSubscribe = data => {
  return async (dispatch, getState) => {
    const id = data.id
    const token = getState().admin.token

    delete data['id']
    var subscribe = {
      membershipId: id
    }
    try {
      var userId = data.userId
      var guardians = data.guardians
      var deletedGuardians = data.deletedGuardians

      delete data['userId']
      delete data['guardians']
      delete data['deletedGuardians']

      for (var i = 0; i < deletedGuardians.length; i++) {
        var guardian = deletedGuardians[i]
        await axios.delete(
          config.serverURL + '/Guardians/' + guardian + '?access_token=' + token
        )
      }

      for (var j = 0; j < guardians.length; j++) {
        var guardian2 = guardians[j]
        if (guardian2.id) {
          await axios.patch(
            config.serverURL +
              '/Guardians/' +
              guardian2.id +
              '?access_token=' +
              token,
            guardian2
          )
        } else if (!guardian2.temp) {
          guardian2.userId = userId
          await axios.post(
            config.serverURL + '/Guardians?access_token=' + token,
            guardian2
          )
        }
      }
      await axios.patch(
        config.serverURL + '/Memberships/' + id + '?access_token=' + token,
        data
      )
      var response = await axios.post(
        config.serverURL + '/Memberships/subscribe?access_token=' + token,
        subscribe
      )
      if (response.data.status.status === 'fail') {
        dispatch({ type: REQUEST_FAILED })
        return
      }

      dispatch({ type: REQUEST_FINISHED2 })
    } catch (error) {
      console.log(error.message)
      dispatch({ type: REQUEST_FAILED })
    }
  }
}

export const newUserMember = data => {
  return async (dispatch, getState) => {
    const token = getState().admin.token
    var user = data.user
    user.address = {
      city: user.city,
      county: user.county,
      country: user.country,
      street1: user.address1,
      street2: user.address2,
      postcode: user.postcode
    }

    delete user['city']
    delete user['county']
    delete user['country']
    delete user['address1']
    delete user['address2']
    delete user['postcode']

    user.adminId = getState().admin.user.id
    try {
      dispatch({ type: REQUEST_SENT })
      const response = await axios.post(
        config.serverURL + '/OnsiteUsers?access_token=' + token,
        user
      )

      var membership = data.membership
      membership.userId = response.data.id

      var guardians = data.guardians
      delete data['guardians']

      for (var i = 0; i < guardians.length; i++) {
        var guardian = guardians[i]
        if (guardian.id) {
          await axios.patch(
            config.serverURL +
              '/Guardians/' +
              guardian.id +
              '?access_token=' +
              token,
            guardian
          )
        } else if (!guardian.temp) {
          guardian.userId = response.data.id
          await axios.post(
            config.serverURL + '/Guardians?access_token=' + token,
            guardian
          )
        }
      }

      const newMembership = await createMembershipRecord(token, membership)
      if (newMembership.isStripe || membership.isStripe) {
        try {
          await sendMembershipConfirmationEmail(
            token,
            newMembership,
            response.data.id
          )
        } catch (emailErr) {
          console.log('membership email:', emailErr.message)
        }
      }
      dispatch({ type: SET_MEMBERSHIP, membership: newMembership })
      dispatch({
        type: REQUEST_FINISHED,
        user: response.data
      })
    } catch (error) {
      console.log(error.response && error.response.data && error.response.data.error)
      dispatch({ type: REQUEST_FAILED })
    }
  }
}

export const newMember = data => {
  return async (dispatch, getState) => {
    const token = getState().admin.token

    try {
      dispatch({ type: REQUEST_SENT })
      var membership = data.membership
      membership.userId = data.id

      var userId = data.userId
      var guardians = data.guardians
      var deletedGuardians = data.deletedGuardians
      delete data['userId']
      delete data['guardians']
      delete data['deletedGuardians']

      for (var i = 0; i < deletedGuardians.length; i++) {
        var guardian = deletedGuardians[i]
        await axios.delete(
          config.serverURL +
            '/Guardians/' +
            guardian.id +
            '?access_token=' +
            token
        )
      }

      for (var j = 0; j < guardians.length; j++) {
        var guardian2 = guardians[j]
        if (guardian2.id) {
          await axios.patch(
            config.serverURL +
              '/Guardians/' +
              guardian2.id +
              '?access_token=' +
              token,
            guardian2
          )
        } else if (!guardian2.temp) {
          guardian2.userId = userId
          await axios.post(
            config.serverURL + '/Guardians?access_token=' + token,
            guardian2
          )
        }
      }

      const newMembership = await createMembershipRecord(token, membership)
      if (newMembership.isStripe || membership.isStripe) {
        try {
          await sendMembershipConfirmationEmail(
            token,
            newMembership,
            membership.userId
          )
        } catch (emailErr) {
          console.log('membership email:', emailErr.message)
        }
      }
      dispatch({ type: SET_MEMBERSHIP, membership: newMembership })
      dispatch({ type: REQUEST_FINISHED2 })
    } catch (error) {
      console.log(error.message)
      dispatch({ type: REQUEST_FAILED })
    }
  }
}

export const changeFinished = state => {
  return dispatch => {
    dispatch({ type: REGISTER_FINISHED })
  }
}

export const fetchLatest = state => {
  var date = new Date()
  date.setDate(date.getDate() - 7)
  return async (dispatch, getState) => {
    try {
      var params = {
        params: {
          filter: {
            include: [
              {
                relation: 'users',
                scope: {
                  include: ['membership', 'guardians']
                }
              }
            ],
            order: 'insrt_dt',
            limit: 5
          }
        }
      }
      const state = getState()
      const id = state.admin.user.id
      const token = state.admin.token

      const url =
        config.serverURL + '/AdminUsers/' + id + '?access_token=' + token
      const response = await axios.get(url, params)
      const length = response.data.users.length

      dispatch({
        type: FETCH_RECENT,
        users: _.reverse(response.data.users.slice(length - 5, length))
      })
    } catch (error) {
      console.log('users - fetchLatest:', error.message)
      fetchLatestStaff(state)(dispatch, getState)
    }
  }
}

const fetchLatestStaff = state => {
  var date = new Date()
  date.setDate(date.getDate() - 7)
  return async (dispatch, getState) => {
    try {
      var params = {
        params: {
          filter: {
            include: [
              {
                relation: 'users',
                scope: {
                  include: ['membership', 'guardians']
                }
              }
            ],
            order: 'insrt_dt',
            limit: 5
          }
        }
      }
      const state = getState()
      const id = state.admin.user.id
      const token = state.admin.token

      const url =
        config.serverURL + '/StaffUsers/' + id + '?access_token=' + token
      const response = await axios.get(url, params)
      const length = response.data.users.length

      console.log('fetchLatestStaff response:', response)

      dispatch({
        type: FETCH_RECENT,
        users: _.reverse(response.data.users.slice(length - 5, length))
      })
    } catch (error) {
      console.log('users - fetchLatestStaff:', error.message)
    }
  }
}

export const fetchNone = userId => {
  return async (dispatch, getState) => {
    try {
      const state = getState()
      const token = state.admin.token

      const response = { data: [] }
      var response2 = { data: [] }

      //--------- check overlapping account - need to filter those opened for membership ---------//
      // const onsitemap = response2.data.map(r => r.email)
      // let overlapping = []
      // overlapping = response.data.filter(r => onsitemap.includes(r.email))
      //------END check overlapping account - need to filter those opened for membership ---------//

      const onsitemap = response2.data.map(r => r.email)
      let overlapping = []
      overlapping = response.data.filter(r => onsitemap.includes(r.email))
      let overlapping2 = []
      overlapping2 = overlapping.filter(r2 => r2.membership)

      response2.data.forEach(user => {
        if (!user.guardians) {
          user.guardians = []
        }
      })

      dispatch({
        type: FETCH_NONE,
        users: response.data.concat(response2.data)
      })
    } catch (error) {
      console.log('users - fetchAll:', error.message)
    }
  }
}

export const fetchAll = userId => {
  return async (dispatch, getState) => {
    try {
      const state = getState()
      const token = state.admin.token

      const url =
        config.serverURL +
        '/OnsiteUsers?filter={"include":["membership","guardians"]}&access_token=' +
        token
      // const url = config.serverURL + '/OnsiteUsers?access_token=' + token
      const response = await axios.get(url)
      var response2 = await axios.get(
        config.serverURL + '/WKUsers?access_token=' + token
      )

      //--------- check overlapping account - need to filter those opened for membership ---------//
      // const onsitemap = response2.data.map(r => r.email)
      // let overlapping = []
      // overlapping = response.data.filter(r => onsitemap.includes(r.email))
      //------END check overlapping account - need to filter those opened for membership ---------//

      const onsitemap = response2.data.map(r => r.email)
      let overlapping = []
      overlapping = response.data.filter(r => onsitemap.includes(r.email))
      let overlapping2 = []
      overlapping2 = overlapping.filter(r2 => r2.membership)

      response2.data.forEach(user => {
        if (!user.guardians) {
          user.guardians = []
        }
      })

      dispatch({
        type: FETCH_ALL,
        users: response.data.concat(response2.data)
      })
    } catch (error) {
      console.log('users - fetchAll:', error.message)
    }
  }
}

export const clearFetchAll = data => {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_ALL_DONE })
  }
}

export const clearFetchNone = data => {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_NONE_DONE })
  }
}

export const updateUser = data => {
  return async (dispatch, getState) => {
    try {
      const state = getState()
      const token = state.admin.token
      if (!data.id || !data.properties) return
      const url =
        config.serverURL + '/OnsiteUsers/' + data.id + '?access_token=' + token
      await axios.patch(url, data.properties)

      state.users.users.forEach(user => {
        if (user.id === data.id) {
          var keys = Object.keys(data.properties)

          keys.forEach(key => {
            user[key] = data.properties[key]
          })
        }
      })

      state.users.recentUsers.forEach(user => {
        if (user.id === data.id) {
          var keys = Object.keys(data.properties)

          keys.forEach(key => {
            user[key] = data.properties[key]
          })
        }
      })

      dispatch({
        type: UPDATE_USER,
        users: state.users,
        recentUsers: state.users.recentUsers
      })
    } catch (error) {}
  }
}

export const updateWKUser = data => {
  return async (dispatch, getState) => {
    try {
      const state = getState()
      const token = state.admin.token
      if (!data.id || !data.properties) return
      const url =
        config.serverURL + '/WKUsers/' + data.id + '?access_token=' + token
      await axios.patch(url, data.properties)

      state.users.users.forEach(user => {
        if (user.id === data.id) {
          var keys = Object.keys(data.properties)

          keys.forEach(key => {
            user[key] = data.properties[key]
          })
        }
      })

      state.users.recentUsers.forEach(user => {
        if (user.id === data.id) {
          var keys = Object.keys(data.properties)

          keys.forEach(key => {
            user[key] = data.properties[key]
          })
        }
      })

      dispatch({
        type: UPDATE_WKUSER,
        users: state.users,
        recentUsers: state.users.recentUsers
      })
    } catch (error) {}
  }
}

export const checkingRedirect = user => {
  return async (dispatch, getState) => {
    dispatch({ type: CHECKING_REDIRECT, user: user })
  }
}

export const redirectDone = user => {
  return async (dispatch, getState) => {
    dispatch({ type: REDIRECT_DONE, user: user })
  }
}

export const newUserRequired = redirect => {
  return async (dispatch, getState) => {
    dispatch({ type: USER_REQUIRED, redirect: redirect })
  }
}

export const newUserNotRequired = state => {
  return async (dispatch, getState) => {
    dispatch({ type: USER_NOT_REQUIRED })
  }
}
